<template>
	<UPageSection
		:id="`page-section-${copy.id}`"
		orientation="horizontal"
		:ui="{
			leading: 'text-2xl sm:text-3xl lg:text-4xl text-pretty tracking-tight font-semibold text-primary mb-1',
			title: 'text-2xl sm:text-3xl lg:text-4xl text-pretty tracking-tight font-semibold text-highlighted',
			container: 'max-w-5xl'
		}"
	>
		<template #leading>
			<motion.p
				v-if="copy.content.leading"
				:while-in-view="{ opacity: 1 }"
				:initial="{ opacity: 0 }"
				:transition="{ delay: 0.4 }"
				:in-view-options="{ once: true }"
				class="text-primary font-semibold text-4xl"
			>
				<span v-html="copy.content.leading" />
			</motion.p>
		</template>
		<template #title>
			<motion.p
				v-if="copy.content.title"
				:while-in-view="{ opacity: 1 }"
				:initial="{ opacity: 0 }"
				:transition="{ delay: 0.4 }"
				:in-view-options="{ once: true }"
				class="text-highlighted"
			>
				<span v-html="copy.content.title" />
			</motion.p>
		</template>
		<template #description>
			<motion.p
				v-if="copy.content.description"
				:while-in-view="{ opacity: 1, transform: 'translateX(0px)' }"
				:initial="{ opacity: 0, x: 10 }"
				:transition="{ duration: 0.4, delay: 0.5 }"
				class="pb-4"
				:in-view-options="{ once: true }"
			>
				<span v-html="copy.content.description" />
			</motion.p>
			<motion.p
				v-if="copy.content.description2"
				:while-in-view="{ opacity: 1, transform: 'translateX(0px)' }"
				:initial="{ opacity: 0, x: 10 }"
				:transition="{ duration: 0.4, delay: 0.6 }"
				class="pb-4"
				:in-view-options="{ once: true }"
			>
				<span v-html="copy.content.description2" />
			</motion.p>
			<motion.p
				v-if="copy.content.description3"
				:while-in-view="{ opacity: 1, transform: 'translateX(0px)' }"
				:initial="{ opacity: 0, x: 10 }"
				:transition="{ duration: 0.4, delay: 0.7 }"
				class=""
				:in-view-options="{ once: true }"
			>
				<span v-html="copy.content.description3" />
			</motion.p>
			<slot name="cta">
				<Motion
					as-child
					:while-in-view="{ opacity: 1, transform: 'translateY(0px)' }"
					:initial="{ opacity: 0, transform: 'translateY(25px)' }"
					:transition="{ type: 'spring', bounce: 0.5, duration: 1, delay: 0.1 }"
					:in-view-options="{ once: true }"
					class="will-change-transform"
				>
					<UButton
						:to="copy.cta?.to"
						:label="copy.cta?.label"
						size="xl"
						class="mt-6"
					/>
				</Motion>
			</slot>
		</template>
	</UPageSection>
</template>

<script setup lang="ts">
import {
	motion, Motion
} from 'motion-v'

type BusinessFiberCTAPageSectionCopy = {
	id: string
	content: {
		leading: string
		title: string
		description: string
		description2: string
		description3: string
	}
	cta: {
		label: string
		to: string
	}
}

defineProps({
	copy: {
		type: Object as PropType<BusinessFiberCTAPageSectionCopy>,
		required: true
	}
})
</script>
